// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import MobileDropdownController from "./mobile_dropdown_controller"
application.register("mobile-dropdown", MobileDropdownController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ScrollBottomController from "./scroll_bottom_controller"
application.register("scroll-bottom", ScrollBottomController)
import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
import RequireInputController from "./require_input_controller"
application.register("require-input", RequireInputController)
import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import HeaderTypeToggleController from "./header_type_toggle_controller"
application.register("header-type-toggle", HeaderTypeToggleController)

import ConversationScrollController from "./conversation_scroll_controller"
application.register("conversation-scroll", ConversationScrollController)

import DomainModeController from "./domain_mode_controller"
application.register("domain-mode", DomainModeController)

import InboxController from "./inbox_controller"
application.register("inbox", InboxController)

import InboxLayoutController from "./inbox_layout_controller"
application.register("inbox-layout", InboxLayoutController)

import ConversationSearchController from "./conversation_search_controller"
application.register("conversation-search", ConversationSearchController)

import TemplateVariablesController from "./template_variables_controller"
application.register("template-variables", TemplateVariablesController)

import TemplateModalController from "./template_modal_controller"
application.register("template-modal", TemplateModalController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import KanbanController from "./kanban_controller"
application.register("kanban", KanbanController)

import ToggleUsageController from "./toggle_usage_controller"
application.register("toggle-usage", ToggleUsageController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import KbEntryTypeController from "./kb_entry_type_controller"
application.register("kb-entry-type", KbEntryTypeController)

import FeatureToggleController from "./feature_toggle_controller"
application.register("feature-toggle", FeatureToggleController)

import BotScheduleController from "./bot_schedule_controller"
application.register("bot-schedule", BotScheduleController)

import FragmentoPickerController from "./fragmento_picker_controller"
application.register("fragmento-picker", FragmentoPickerController)

import ComposeBoxController from "./compose_box_controller"
application.register("compose-box", ComposeBoxController)

import FathomImportController from "./fathom_import_controller"
application.register("fathom-import", FathomImportController)

import SubmitLockController from "./submit_lock_controller"
application.register("submit-lock", SubmitLockController)

import RoleFieldsController from "./role_fields_controller"
application.register("role-fields", RoleFieldsController)

import TrialSubdomainController from "./trial_subdomain_controller"
application.register("trial-subdomain", TrialSubdomainController)

import FillInputController from "./fill_input_controller"
application.register("fill-input", FillInputController)

import AutoConfigController from "./auto_config_controller"
application.register("auto-config", AutoConfigController)

import FieldTypeController from "./field_type_controller"
application.register("field-type", FieldTypeController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import SetupStepsController from "./setup_steps_controller"
application.register("setup-steps", SetupStepsController)
